export default __webpack_public_path__ + "static/26-100-658b153798fda01f65df686c9815b2e6.jpg";